export const SET_CORDOVA_INITIALIZE		= "SET_CORDOVA_INITIALIZE";
export const SET_PUSH_AVAILABLE			= "SET_PUSH_AVAILABLE";
export const SET_HEALTH_AVAILABLE		= "SET_HEALTH_AVAILABLE";

export const actionSetCordovaInitialize	= initialized => ({ type: SET_CORDOVA_INITIALIZE, initialized:initialized });
export const actionSetPushAvailable		= available => ({ type: SET_PUSH_AVAILABLE, available:available });
export const actionSetHealthAvailable	= available => ({ type: SET_HEALTH_AVAILABLE, available:available });
